// 机场设置相关请求
import req from './index'

//获取机场列表
export const getAirPortListAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.GetCompanyDockInfo', params)
}

//修改 机场信息
export const setAirPortListAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.SetCompanyDockInfo', params)
}

//验证 机场编号是否存在
export const verifyAirPortSnAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.getDockExists', params)
}

//重启 机场
export const restartDockAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.reboot', params)
}

//删除 机场信息
export const delAirPortListAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.setCompanyDockOnOff', params)
}